import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormBuildersComponent} from './form-builders.component';

const routes: Routes = [
  {
    path: '',
    component: FormBuildersComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FormBuildersRoutingModule { }
